// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version and command lines
// MODFIED DATE : 05-09-2025

// /* eslint-disable eslint-comments/disable-enable-pair */

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

// PARTIES DETAIL ADD FUNCTION
export const partiesDetailsAdd = (partiesData: any) => {
	const data = {
		AddBusinessTokenReletedParties: partiesData,
	};
	const url = `${API_URL}addRelatedParties`;
	return makeApiCall(url, data);
};

// FETCH PARTIE DETAILS FUNCTION
export const fetchPartiesDetails = (fetchData: any) => {
	const data = {
		GetBusinessTokenReletedParties: fetchData,
	};
	const url = `${API_URL}getRelatedParties`;
	return makeApiCall(url, data);
};

// UPDATE PARTIES DETAILS FUNCTION
export const updatePartiesDetails = (updateData: any) => {
	const data = {
		UpdateReletedPartiesDetailsToken: updateData,
	};
	const url = `${API_URL}updateRelatedParties`;
	return makeApiCall(url, data);
};

// DELETE PARTIES DETAILS FUNCTION
export const deletePartiesDetails = (deleteData: any) => {
	const data = {
		DeleteReletedPartiesDetailsToken: deleteData,
	};
	const url = `${API_URL}deleteRelatedParties`;
	return makeApiCall(url, data);
};
